import PropTypes from 'prop-types';

import './index.less';
import Statistic from '$src/components/Statistic';

function SummaryCard({ title, amount, Icon, success, danger, footer, isSelected, hasOpacity, onSelect }) {
  return (
    <div
      data-testid="summary-card"
      className={`summary-card summary-card${isSelected ? '--selected' : ''} summary-card${hasOpacity ? '--opacity' : ''}`}
      onClick={onSelect}
    >
      <Statistic title={title} value={amount} Icon={Icon} success={success} danger={danger} />
      <span className="summary-card__footer">{footer}</span>
    </div>
  );
}

SummaryCard.propTypes = {
  title: PropTypes.string,
  amount: PropTypes.number,
  Icon: PropTypes.elementType,
  footer: PropTypes.string,
  isSelected: PropTypes.bool,
  hasOpacity: PropTypes.bool,
  onSelect: PropTypes.func,
};

SummaryCard.defaultProps = {
  title: '',
  amount: 0,
  Icon: null,
  footer: 'Click to filter values',
};

export default SummaryCard;
